<template>
  <div class="Child">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="getSelectEvent">获取选中</el-button>
        <el-button type="primary" @click="funcFilter()">查询</el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      height="500"
      :data="tableData"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      
      <vxe-table-column>
        <vxe-table-column field="licenseNumber" title="车辆牌照号" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.licenseNumber" placeholder="请输入车辆牌照号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="teamName" title="车队名称" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.teamName" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="driverName" title="驾驶员姓名" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.driverName" placeholder="请输入驾驶员姓名" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="driverPhone" title="联系方式" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.driverPhone" placeholder="请输入联系方式" clearable />
        </template>
      </vxe-table-column>
    
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { vehicle } from "@/api/transport";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        authStatus: 3,
        driverPhone: "",
        driverName: "",
        loadWeight: "",
        roadTransportCertificateNumber: "",
        licenseNumber: "",
        branchCodeExt: ""
      },
      Pagingconf: [],
      selectRecords: []
    };
  },
  created() {
    this.listQuery.branchCodeExt = JSON.parse(localStorage.getItem('dataBranch')).code;
  },
  methods: {
    designcar() {
      vehicle(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.designcar(this.listQuery.branchCodeExt);
    },
    getSelectEvent() {
      this.selectRecords = this.$refs.xTable.getCheckboxRecords();
      this.$emit("event2", this.selectRecords);
    },

    // 取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    // 选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.designcar();
    }
  }
};
</script>

<style>
</style>
